import React from 'react';

export const Card = ({ children, className = '', title, action }) => (
  <div className={`bg-chefDark border border-chefPanel rounded-lg flex flex-col ${className}`}>
    {(title || action) && (
      <div className="flex justify-between items-center p-4 border-b border-chefPanel">
        {title && <h3 className="text-receiptWhite font-mono text-sm tracking-wider uppercase">{title}</h3>}
        {action && <div>{action}</div>}
      </div>
    )}
    <div className="p-4 flex-1 overflow-auto">
      {children}
    </div>
  </div>
);